/**
 * Created by Florin David on 30/06/2020.
 */

import Action, { SET_FETCHING_RESPONSE } from 'constants/action-types'

/**
 * Generic errors
 */
export default (state = false, action: Action): boolean => {
  switch (action.type) {
    case SET_FETCHING_RESPONSE:
      return action.payload
    default:
      return state
  }
}
